<template>
  <div>
    <HeaderSteps title="New flight" :steps="steps" :active="currentStep" :back-path="-1"></HeaderSteps>
    <template v-if="currentStep === 0">
      <CampaignPeriod @step="getCurrentStep" />
    </template>
    <template v-if="currentStep === 1">
      <Assets />
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignPeriod from '@/components/social-products/social-boost/forms/PeriodBudget.vue'
import Assets from '@/components/social-products/social-boost/forms/Assets.vue'
import SocialBoostCampaignMixin from '@/mixins/social-products/social-boost-campaign'

export default {
  name: 'CreateFlight',
  mixins: [SocialBoostCampaignMixin],
  components: {
    HeaderSteps,
    CampaignPeriod,
    Assets,
  },
  data() {
    return {
      steps: ['Period and budget', 'Assets'],
      currentStep: 0,
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
    ...mapGetters('app', ['is_loading']),
  },
  methods: {
    getCurrentStep(step) {
      this.currentStep = step === 2 ? 1 : step
    },
    async init() {
      const res = await this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.$route.params.id })

      if (res) {
        const campaignData = this.clientDataByClient(res.client, res.publisher)
        this.$store.commit('socialBoostCampaign/SET_CAMPAIGN_FORM', { section: 'details', data: campaignData })
      }
    },
  },
}
</script>
